'use strict';

angular.module('atex.art').directive('tooltip', ['$rootScope', function($rootScope) {
  return {
    link: function(scope, element, attrs) {
      var $window = $(window),
        $element = $(element),
        $tip = undefined,
        removeRouteListener = undefined,
        hideFn = function() {
          $element.tooltip("hide");
        },
        clickFn = function(e) {
          if($element.is(e.target)) {
            return;
          }

          if($tip.has(e.target).length === 0) {
            hideFn();
          }
        };

      $element.addClass("tooltip-trigger").tooltip({
        container: 'body',
        placement: $element.attr("x-placement") || 'top',
        trigger: 'click'
      });

      $element.on("shown.bs.tooltip", function() {
        $tip = $tip || $element.data("bs.tooltip").$tip;
        $window.on("resize", hideFn);
        $(document).on("click touchend", clickFn);
        removeRouteListener = $rootScope.$on("$routeChangeStart", hideFn);
      });

      $element.on("hidden.bs.tooltip", function() {
        $tip.detach();
        $window.off("resize", hideFn);
        $(document).off("click touchend", clickFn);
        if(removeRouteListener !== undefined) {
          removeRouteListener();
        }
      });
    }
  };
}]);
